import Vue from 'vue'
import Vuex from 'vuex'
import title from './modules/title'
import auth from './modules/auth'
import register from './modules/register'
import profile from './modules/profile'
import fundraiser from './modules/fundraiser'
import campaign from './modules/campaign'
import upgradeAccount from './modules/upgrade-account'
import checkout from './modules/checkout'
import axios from 'axios'
import constants from '../config'
import dayjs from 'dayjs'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    errors: null,
    alert: {
      message: null,
      type: null,
    },
    authUser: {
      authenticated: null,
      registered: null,
      verified: null,
      fetchedAt: null,
      roles: null,
      expired: true,
      data: null,
    }
  },

  getters: {
    errors: state => state.errors,
    alert: state => state.alert,
    authUser: state => state.authUser,
  },

  mutations: {
    setFetchedAuthUser (state, user) {
      let userState = {
        authenticated: false,
        registered: null,
        verified: null,
        fetchedAt: null,
        roles: null,
        data: null,
      }

      if (user) {
        userState.authenticated = true
        userState.registered = user.data.attributes.registered
        userState.verified = user.data.attributes.verified
        userState.fetchedAt = dayjs()
        userState.expired = false
        userState.roles = user.data.attributes.roles
        userState.data = { ...user.data }
      }

      state.authUser = userState
    },

    setAuthUser (state, user) {
      state.authUser = user
    },

    setErrors (state, errors) {
      state.errors = errors
    },

    setAlert (state, alert) {
      if (_.isEmpty(alert)) {
        alert = {
          message: null,
          type: null,
        }
      }

      state.alert = alert
    }
  },

  actions: {
    fetchAuthUser ({commit}) {
      return axios.get(constants.BASE_URL + 'auth/show')
       .then(function (resp) {
         commit('setFetchedAuthUser', resp.data)
       })
       .catch(function (resp) {
         commit('setFetchedAuthUser', null)
       })
    },

    updateAuthUser({commit, state}) {
      let user = state.authUser
      user.expired = true

      if (user.fetchedAt !== null && user.fetchedAt instanceof dayjs) {
        user.expired = dayjs().isAfter(user.fetchedAt.add(constants.USER_DATA_EXPIRE_TIME, 'minute'))
      }
      commit('setAuthUser', user)
    }
  },

  modules: {
    title,
    auth,
    register,
    profile,
    fundraiser,
    checkout,
    campaign,
    upgradeAccount,
  }
})
